import { render, staticRenderFns } from "./MemberCenter.vue?vue&type=template&id=5d576b2b"
import script from "./MemberCenter.vue?vue&type=script&lang=js"
export * from "./MemberCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports